"use client"

import type { InputHTMLAttributes, ReactNode, Ref } from "react"

import { useFieldA11y, type FieldShape, type FieldSize, type FieldState } from "@/components/ui/field"

interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  autoComplete: string
  label?: string
  help?: ReactNode
  state?: FieldState
  size?: FieldSize
  shape?: FieldShape
  leading?: ReactNode
  trailing?: ReactNode
  ref?: Ref<HTMLInputElement>
}

export const TextInput = ({ label, help, state, size, shape, leading, trailing, disabled, className, id, ref, ...rest }: TextInputProps) => {
  const { fieldId, helpId, styles, controlProps } = useFieldA11y({ id, help, state, size, shape, disabled })
  return (
    <div className={styles.root({ className })}>
      {label && (
        <label htmlFor={fieldId} className={styles.label()}>
          {label}
        </label>
      )}
      <div className={styles.control({ className: "flex items-center gap-250" })}>
        {leading && <span className="text-fg-subtle flex shrink-0 items-center">{leading}</span>}
        <input ref={ref} disabled={disabled} {...controlProps} className={styles.input({ className: disabled ? "text-fg-muted cursor-not-allowed" : "" })} {...rest} />
        {trailing && <span className="text-fg-subtle flex shrink-0 items-center">{trailing}</span>}
      </div>
      {help && (
        <div id={helpId} className={styles.help()}>
          {help}
        </div>
      )}
    </div>
  )
}
